import { Modal } from '../../../Components/Common/Modal'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Dialog di conferma dei comandi della pagina: descrizione e avviso evidenziato
 * facoltativo (scritture esterne, effetti in corso). Non chiama il server:
 * `onConferma` decide.
 *
 * @param {Object} props - Proprietà
 * @param {boolean} props.visible - Visibilità
 * @param {() => void} props.onHide - Chiusura
 * @param {string} props.titolo - Titolo
 * @param {string} props.descrizione - Cosa succede se si conferma
 * @param {string} [props.avviso] - Avviso evidenziato
 * @param {string} [props.etichettaConferma] - Testo del bottone di conferma
 * @param {boolean} [props.inCorso] - Comando in esecuzione
 * @param {() => void} props.onConferma - Conferma
 * @returns {import('react').JSX.Element}
 */
export const DialogConferma = ({
  visible,
  onHide,
  titolo,
  descrizione,
  avviso,
  etichettaConferma,
  inCorso = false,
  onConferma
}) => (
  <Modal
    visible={visible}
    header={titolo}
    onHide={onHide}
    className="nora-dialog"
    contentStyle={{ padding: 0 }}
    style={{ width: 'min(520px, 92vw)' }}
  >
    <div className="nora-dialog__body--compact" style={{ display: 'grid', gap: 12 }}>
      <p className="nora-dialog__message" style={{ margin: 0 }}>
        {descrizione}
      </p>
      {avviso && (
        <div
          role="alert"
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            padding: '10px 12px',
            borderRadius: 'var(--radius-md)',
            background: 'var(--surface-2)',
            border: '1px solid var(--border)'
          }}
        >
          <span className="nbadge nbadge--warn">
            <i className="pi pi-triangle-exclamation" style={{ fontSize: 11 }} />
          </span>
          <span style={{ fontSize: 13, color: 'var(--ink-700)' }}>{avviso}</span>
        </div>
      )}
    </div>
    <div className="nora-dialog__body nora-dialog__footer">
      <button type="button" className="nbtn" onClick={onHide} disabled={inCorso}>
        {t.annulla}
      </button>
      <button
        type="button"
        className="nbtn nbtn--primary"
        onClick={() => onConferma()}
        disabled={inCorso}
      >
        {etichettaConferma || t.conferma}
      </button>
    </div>
  </Modal>
)

export default DialogConferma
